import * as React from "react";
import { inject, observer } from "mobx-react";
import { NativeTileShowcaseProps } from "./typings";
import { NativeAd } from "components/utility/Ads/NativeAd";
import { MesoNativeTileShowcaseFallback } from "./Fallback";
import { withMabTracker, MabTrackEvent } from "components/utility/analytics/MabTracker";
/**
 * Native ad component that renders web components served from the MeSo Ads Delivery Service.
 * @see https://github.expedia.biz/MediaSolutions/ads-delivery-service/wiki
 */
export const NativeTileShowcase: React.SFC<NativeTileShowcaseProps> = withMabTracker(
  inject("advertising")(
    observer((props: NativeTileShowcaseProps) => {
      const { flexComponent, mabTrack } = props;
      const model = flexComponent.model;
      const nativeAdCssClass = "uitk-card horizontal-placeholder uitk-card-with-border";

      const cardClicked = mabTrack
        ? () => {
            const mabTrackData: MabTrackEvent = {
              moduleName: "in_the_spotlight",
              eventTarget: "in_the_spotlight",
              eventType: "homepageClick.nonPath",
              rfrr: "native-tile-showcase.In_the Spotlight",
            };
            mabTrack(mabTrackData);
          }
        : undefined;

      return (
        <div
          className={`NativeTileShowcase uitk-cell all-b-padding-three all-cell-1-1 ${
            model.title ? "" : "all-t-padding-three"
          } ${model.stackedPadding ? "NativeShowcasePadding" : ""}`}
          id={flexComponent.id}
          data-fm={flexComponent.fmId}
          data-fm-title-id={flexComponent.fmTitleId}
          onClick={cardClicked}
          data-testid="native-title-showcase"
        >
          {model.title && (
            <h2 className="uitk-type-heading-600 all-t-padding-three all-b-padding-three">{model.title}</h2>
          )}
          <NativeAd uci={model.uci} type="gpt-native" className={nativeAdCssClass} showFallback={model.showFallback}>
            <MesoNativeTileShowcaseFallback {...model} />
          </NativeAd>
        </div>
      );
    })
  )
);

export default NativeTileShowcase;
